import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function AuthAccessStatus({ failed, mainTarget = true, checking = "Checking your access…", signInHref }: {
  failed: boolean;
  checking?: string;
  mainTarget?: boolean;
  signInHref?: string;
}) {
  return (
    <div role={mainTarget ? "main" : undefined} id={mainTarget ? "main-content" : undefined} tabIndex={mainTarget ? -1 : undefined} className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background text-foreground px-6 text-center">
      {failed ? (
        <>
          <div role="alert">
            <h1 className="text-lg font-semibold">We couldn't finish checking your access</h1>
            <p className="mt-2 text-sm text-muted-foreground">Check your connection, then try again. Your saved work has not changed.</p>
          </div>
          <Button type="button" onClick={() => window.location.reload()}>Try again</Button>
          {signInHref && <Link to={signInHref} className="underline underline-offset-4 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring">Go to sign in</Link>}
        </>
      ) : (
        <div role="status" aria-live="polite">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground mx-auto mb-3" aria-hidden />
          <p className="text-sm text-muted-foreground">{checking}</p>
        </div>
      )}
    </div>
  );
}
